/**
 * 语音上下文 Provider（T10）。
 *
 * 由 ChatPage 用 `useVoiceController()` 生成 value，再包住整页子树；
 * 助手气泡的播放按钮与输入区语音控制在子树内用 `useVoice()` 读取。
 */

import type { ReactElement, ReactNode } from 'react';

import { VoiceContext } from './context';
import type { VoiceContextValue } from './context';

export interface VoiceProviderProps {
  value: VoiceContextValue;
  children: ReactNode;
}

export function VoiceProvider({ value, children }: VoiceProviderProps): ReactElement {
  return <VoiceContext.Provider value={value}>{children}</VoiceContext.Provider>;
}